<ion-header>
  <ion-toolbar>
    <ion-title>Select Addons</ion-title>
    <ion-button slot="end" fill="clear" class="white" color="primary-pos-bg" (click)="close()">
      <ion-icon name="close-sharp"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container" *ngIf="product_info">
    <div class="top__container">
      <div class="side__container">
        <div class="mobile__desc">
          <!-- <div> -->
          <div class="d__flex just-s">
            <h6 class="product__name">{{product_info.item}}</h6>
          </div>
          <div class="m-0 brand-name" *ngIf="product_info.brands && product_info.brands.length !=0 ">by <span class="alternative" *ngFor="let b of product_info.brands">{{b.brand_name}}</span></div>
          <div class="product__categories fnt-14" *ngIf="product_info.product_categories && product_info.product_categories.length != 0">
            <span>Categories : </span> <a *ngFor="let item of product_info.product_categories;let i = index" routerLink="/category/{{item.category}}">{{item.category_name}} <span *ngIf="i > i-1"></span></a>
            <!-- [routerDirection]="db.ismobile?'':'root'" -->
          </div>
          <!-- </div> -->
          <p class="prices">
            <span class="m-0 price">
              <span class="open_sans__font" *ngIf="product_info.price && !is_weight_price"><span class="sans-font"> </span>{{product_info.price | currency:db.currency}}</span>
              <span class="open_sans__font" *ngIf="product_info.weight_price && is_weight_price"><span class="sans-font"> </span>{{product_info.weight_price | currency:db.currency}}</span>
            </span>
            <span class="m-0 s-price l-t">
              <span class="open_sans__font" *ngIf="product_info.old_price != 0"><span class="sans-font"> </span>{{product_info.old_price | currency:db.currency}}</span>
            </span>
          </p>
        </div>
        <!--Products Attribute Variants -->
        <ion-row>
          <!-- {{db.check_mobile()?12:8}} -->
          <ion-col size="{{db.ismobile?12:6}}" class="p0" *ngIf="product_info.product_attributes && product_info.product_attributes.length != 0">
            <div class="attributes" *ngIf="product_info.product_attributes && product_info.product_attributes.length != 0">
              <!-- Not a table format -->
              <div *ngIf="product_info.show_price != 0">
                <div *ngFor="let item of product_info.product_attributes">
                  <div #attribute_dropdown *ngIf="item.control_type == 'Dropdown List'" class="attribute__drop__down">
                    <h6 class="attribute__name noselect">{{item.attribute}}</h6>
                    <div class="d__flex selected__drop__down mouse noselect" (mouseleave)="item.drop_down = 0">
                      <div class="selected__txt" (click)="item.drop_down = 1">
                        <div> {{check_attribute_labels(item.options)}} </div>
                        <ion-icon class="fnt-12" name="chevron-down-outline"></ion-icon>
                      </div>
                      <div *ngIf="item && item.drop_down == 1" class="drop__down__options" (mouseleave)="item.drop_down = 0">
                        <div [class.active__drop__option]="option.is_pre_selected && option.is_pre_selected == 1" class="drop__down__option mouse" *ngFor="let option of item.options" (click)="select(item.attribute,option.name)" (click)="item.drop_down = 0">
                          {{option.option_value}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Radio button list -->
                  <div #attibute_dropdown *ngIf="item.control_type == 'Radio Button List' && item.attribute != 'Weight'">
                    <h6 class="attribute__name noselect">{{item.attribute}}</h6>
                    <ion-radio-group class="d__flex flex-w gap-10 noselect" [value]="check_active_radio(item.options,item)">
                      <ion-row>
                        <ion-col size="item.options.length" class="p0" *ngFor="let option of item.options">
                          <ion-item lines="none" class="radio__attribute__option  d__flex mouse gap-10" [class.active__radio__option]="option.is_pre_selected && option.is_pre_selected == 1" (click)="select(item.attribute,option.name)">
                            <ion-radio [value]="option.name"></ion-radio>
                            <ion-label>{{option.option_value}}</ion-label>
                          </ion-item>
                        </ion-col>
                      </ion-row>
                    </ion-radio-group>
                    <div class="d__flex flex-w" style="display:none;">
                      <ion-radio-group>
                        <div *ngFor="let option of item.options" class="radio__attribute__option  d__flex mouse" [class.active__radio__option]="option.is_pre_selected && option.is_pre_selected == 1" (click)="select(item.attribute,option.name)">
                          <!-- <div class="main-dot d__flex just-c">
                      <div class="inner-dot d__flex"> </div>
                    </div> -->
                          <!-- <ion-radio slot="start" value="{{option.option_value}}"></ion-radio> -->
                          <ion-item lines="none" class="no-bg">
                            <ion-radio slot="start" value="{{option.is_pre_selected && option.is_pre_selected == 1}}"></ion-radio>
                            <ion-label>{{option.option_value}}</ion-label>
                          </ion-item>
                         
                        </div>
                      </ion-radio-group>
                    </div>
                  </div>
                  <div #attibute_dropdown *ngIf="item.control_type == 'Radio Button List' && item.attribute == 'Weight'">
                    <h6 class="attribute__name noselect">{{item.attribute}}</h6>
                    <ion-radio-group class="d__flex flex-w gap-10" [value]="check_active_radio(item.options,item)">
                      <ion-row>
                        <ion-col class="p0" *ngIf="item.attribute == 'Weight'">
                          <ion-item (click)="check_custom()" lines="none" class="radio__attribute__option  d__flex mouse gap-10">
                            <ion-radio [value]="custom"></ion-radio>
                            <ion-label>Custom</ion-label>
                          </ion-item>
                        </ion-col>
                        <ion-col *ngIf="item.attribute == 'Weight'" class="p0">
                          <div class="parent_col">
                            <div class="child_div">
                              <ion-list class="p0">
                                <!-- <ion-label class="label_box" stacked>Weight (grm)</ion-label> -->
                                <ion-input #weight_focus [disabled]="!is_disble" class="bb h42" type="tel" (ionChange)="calculate_balance()" placeholder="Weight (grm)" [(ngModel)]="weight"></ion-input>
                              </ion-list>
                            </div>
                          </div>
                        </ion-col>
                      </ion-row>
                    </ion-radio-group>
                  </div>
                  <!-- Check Box -->
                  <div class="check__box" *ngIf="item.control_type == 'Checkbox List'">
                    <h6>{{item.attribute}}</h6>
                    <div *ngFor="let option of item.options" class="d__flex gap-10" [ngClass]="(option.is_pre_selected == 1)?'active-checkbox':''" (click)="select(item.attribute,option.name)">
                      <ion-checkbox></ion-checkbox>
                      <div class="nw attri">{{option.option_value}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Table format -->
              <div class="table__attributes" *ngIf="product_info.show_price == 0">
                <div class="d__flex table__attribute" *ngFor="let item of product_info.product_attributes[0].options">
                  <div>
                    <div class="table__header">
                      <div class="image__container">
                        <div class="attribute__image"><img [src]="db.product_img(item.image_attribute)"></div>
                        <div>
                          <h6 class="attribute__heading">{{item.option_value}}</h6>
                          <div class="d__flex gap-10" *ngIf="item.price">
                            <h6 class="m-0">{{item.price | currency:'&#8377;'}}</h6>
                            <p class="m-0 l-t fnt-12">{{item.old_price | currency:'&#8377;'}}</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="no-stock" *ngIf="item.stock_alert_message">{{item.stock_alert_message}}</p>
                      </div>
                    </div>
                    <!-- <div [innerHTML]="item.selected_attribute"></div> -->
                    <div *ngFor="let attribute of product_info.other_attributes">
                      <!-- Radio -->
                      <div *ngIf="attribute.control_type == 'Radio Button List'">
                        <div class="attribute__name">{{attribute.attribute}}</div>
                        <!-- <ion-radio-group> -->
                        <!-- option.is_selected == 1 && option.is_select_parent.option_value == item.option_value -->
                        <div [class.active__radio__option]="check_active(item,option)" class="radio__attribute__option mouse d__flex" *ngFor="let option of attribute.options" (click)="item.attribute = product_info.product_attributes[0].attribute" (click)="select_attribute(item,attribute,option.name)">
                          <!-- <div class="main-dot d__flex just-c">
                        <div class="inner-dot d__flex">
                          <ion-icon src="/assets/icon/tick.svg"></ion-icon>
                        </div>
                      </div> -->
                          <ion-item lines="none" class="no-bg">
                            <ion-radio slot="start" value="{{option.option_value}}"></ion-radio>
                            <ion-label>{{option.option_value}}</ion-label>
                          </ion-item>
                          <!-- <ion-radio slot="start" value="{{option.option_value}}"></ion-radio>
                      <div>{{option.option_value}}</div> -->
                        </div>
                        <!-- </ion-radio-group> -->
                      </div>
                      <!-- Drop down list -->
                      <div class="attribute__drop__down " *ngIf="attribute.control_type == 'Dropdown List'">
                        <div class="attribute__name">{{attribute.attribute}}</div>
                        <div class="selected__drop__down">
                          <div class="selected__txt" (click)="item.drop_down = 1">
                            <div>{{check_attribute_label(attribute.options,item)}}</div>
                            <ion-icon name="chevron-down-outline"></ion-icon>
                          </div>
                          <div *ngIf="item && item.drop_down && item.drop_down == 1" (mouseleave)="item.drop_down = 0" class="drop__down__options">
                            <div [class.active__drop__option]="check_active(item,option)" class="drop__down__option mouse" *ngFor="let option of attribute.options" (click)="item.attribute = product_info.product_attributes[0].attribute" (click)="select_attribute(item,attribute,option.name)">{{option.option_value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div *ngIf="item.selected_attribute" [innerHTML]="item.selected_attribute"></div> -->
                    <div class="cart-buttons d__flex">
                      <div class="cart__button" [class.mouse]="product_info.count == 0" (click)="(product_info.count == 0 )?addtocart(product_info):''">
                        <ion-button class="mouse __button" *ngIf="product_info.count && product_info.count != 0" (click)="removetocart(product_info)" fill="clear"><span>-</span></ion-button>
                        <span class="add" [class.no-add]="product_info.count == 0"> {{product_info.count && (product_info.count != 0)?product_info.count:'Add'}} </span>
                        <ion-button class="mouse __button" (click)="( product_info.count != 0 )?addtocart(product_info):''" [disabled]="(product_info.inventory_method == 'Track Inventory' && (product_info.stock == 0  || product_info.stock <= product_info.count)) || product_info.disable_add_to_cart_button == 1" fill="clear"><span>+</span></ion-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-col>
          <ion-col class="p0" size="{{db.ismobile?12:6}}">
            <ion-grid>
              <ion-row>
                <ion-col class="p0" size="12" *ngIf="!editorder">
                  <div class="parent_col">
                    <div class="child_div">
                      <ion-list class="p0">
                        <ion-label class="label_box" stacked>Custom Price</ion-label>
                        <ion-input class="bb" type="number" (ionChange)="custom_calculate_balance()" [(ngModel)]="custom_price" name="custom_price"></ion-input>
                      </ion-list>
                    </div>
                  </div>
                </ion-col>
                <ion-col class="p0" size="12">
                  <div class="parent_col">
                    <div class="child_div">
                      <ion-list class="p0">
                        <ion-label class="label_box" stacked>Special Instructions</ion-label>
                        <ion-textarea class="bb" [(ngModel)]="instructions"></ion-textarea>
                      </ion-list>
                    </div>
                  </div>
                </ion-col>
                <ion-col class="p0" size="12" *ngIf="!editorder">
                  <div class="parent_col">
                    <div class="child_div">
                      <ion-list class="p0">
                        <ion-label class="label_box" stacked>Tray Number</ion-label>
                        <ion-input class="bb" [(ngModel)]="tray_number" name="tray_number"></ion-input>
                      </ion-list>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-button class="floatRight" *ngIf="product_info.show_price != 0" (click)="addtocart(product_info)">Add Item</ion-button>
</ion-footer>
